import { render, staticRenderFns } from "./ItemAdminDirectMatching.vue?vue&type=template&id=a7612d08&scoped=true"
import script from "./ItemAdminDirectMatching.vue?vue&type=script&lang=js"
export * from "./ItemAdminDirectMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7612d08",
  null
  
)

export default component.exports